var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.style }, [
    _c("div", { attrs: { id: "mobileVote" } }, [
      _c("div", { staticClass: "adDiv" }, [
        _c("div", { staticClass: "ad" }, [
          _c("img", { attrs: { src: _vm.img, alt: "" } })
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "voteName",
            staticStyle: { "white-space": "pre-wrap" }
          },
          [_vm._v(_vm._s(_vm.voteName ? _vm.voteName : "投票活动名称"))]
        ),
        _vm._v(" "),
        _c("p", { staticClass: "voteTime" }, [
          _vm._v(
            "投票时间：" +
              _vm._s(
                _vm._f("dateFormat")(
                  _vm.startTime !== "" ? _vm.startTime : new Date().valueOf(),
                  "yyyy-MM-dd hh:mm:ss"
                )
              ) +
              " 至" +
              _vm._s(
                _vm._f("dateFormat")(
                  _vm.endTime !== "" ? _vm.endTime : new Date().valueOf(),
                  "yyyy-MM-dd hh:mm:ss"
                )
              )
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "voteContent" }, [
        _c("div", { staticClass: "rectangle" }),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v("\n        投票内容\n      ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c(
            "p",
            {
              ref: "contents",
              class: { ps: _vm.isStyle },
              staticStyle: {
                "word-wrap": "break-word",
                "white-space": "pre-wrap"
              }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.content !== "" ? _vm.content : "投票活动规则和活动简介"
                )
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "allShow",
            on: {
              click: function($event) {
                _vm.toggleShow()
              }
            }
          },
          [_vm._v(_vm._s(_vm.allVisible ? "显示全部↓" : "收起↑"))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showStatus1,
                expression: "showStatus1"
              }
            ],
            staticClass: "template1"
          },
          [
            _c(
              "ul",
              { ref: "element", staticClass: "vList" },
              _vm._l(_vm.arr, function(list, index) {
                return _vm.candidateList.length == 0
                  ? _c("li", { key: index }, [
                      _c("div", { staticClass: "img" }, [
                        _c("img", { attrs: { src: list.itemImage, alt: "" } }),
                        _vm._v(" "),
                        _c("div", { staticClass: "triangle" }, [
                          _c("p", [_vm._v(_vm._s(list.itemIndex))])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "name" }, [
                        _vm._v(_vm._s(list.itemTitle))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "tip" }, [
                        _vm._v(_vm._s(list.itemDescription))
                      ]),
                      _vm._v(" "),
                      _c("button", { staticClass: "btn-vote" }, [
                        _vm._v("投票")
                      ])
                    ])
                  : _vm._e()
              })
            )
          ]
        ),
        _vm._v(" "),
        _vm.candidateList.length > 0
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showStatus1,
                    expression: "showStatus1"
                  }
                ],
                ref: "temp1",
                staticClass: "template1"
              },
              [
                _c(
                  "ul",
                  { staticClass: "vList" },
                  _vm._l(_vm.candidateList, function(list, index) {
                    return _c("li", { key: index }, [
                      _c("div", { staticClass: "img" }, [
                        _c("img", { attrs: { src: list.itemImage, alt: "" } }),
                        _vm._v(" "),
                        _c("div", { staticClass: "triangle" }, [
                          _c("p", [_vm._v(_vm._s(list.itemIndex))])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "name",
                          staticStyle: { "font-size": "14px", color: "#333" }
                        },
                        [_vm._v(_vm._s(list.itemTitle))]
                      ),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "tip",
                          staticStyle: { "font-size": "12px", color: "#666" }
                        },
                        [_vm._v(_vm._s(list.itemDescription))]
                      ),
                      _vm._v(" "),
                      _c("button", { staticClass: "btn-vote" }, [
                        _vm._v("投票")
                      ])
                    ])
                  })
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.candidateList.length == 0
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showStatus2,
                    expression: "showStatus2"
                  }
                ],
                staticClass: "template2"
              },
              [
                _c(
                  "ul",
                  { staticClass: "vList" },
                  _vm._l(_vm.arr, function(list, index) {
                    return _c("li", { key: index }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showStatus3,
                              expression: "showStatus3"
                            }
                          ],
                          staticClass: "left"
                        },
                        [
                          _c("img", {
                            attrs: { src: list.itemImage, alt: "" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "triangle" }, [
                            _c("p", [_vm._v(_vm._s(list.itemIndex))])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showStatus3,
                              expression: "showStatus3"
                            }
                          ],
                          staticClass: "right",
                          staticStyle: {
                            "padding-top": "12px",
                            "font-size": "16px",
                            overflow: "hidden",
                            "text-overflow": "ellipsis",
                            "white-space": "nowrap",
                            "margin-bottom": "10px"
                          }
                        },
                        [
                          _c("div", [
                            _c("p", [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.showStatus3,
                                      expression: "!showStatus3"
                                    }
                                  ]
                                },
                                [_vm._v(_vm._s(list.itemIndex))]
                              ),
                              _vm._v(_vm._s(list.itemTitle))
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "tip",
                              staticStyle: {
                                "font-size": "14px",
                                "line-height": "23px"
                              }
                            },
                            [_vm._v(_vm._s(list.itemDescription))]
                          ),
                          _vm._v(" "),
                          _c("button", { staticClass: "btn-vote" }, [
                            _vm._v("投票")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.showStatus3,
                              expression: "!showStatus3"
                            }
                          ],
                          staticClass: "right right1"
                        },
                        [
                          _c("div", [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  padding: "12px 0 0 12px",
                                  "font-size": "16px"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.showStatus3,
                                        expression: "!showStatus3"
                                      }
                                    ]
                                  },
                                  [_vm._v(_vm._s(list.itemIndex))]
                                ),
                                _vm._v(_vm._s(list.itemTitle))
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "tip",
                              staticStyle: {
                                "font-size": "14px",
                                padding: "8px 0 0 12px"
                              }
                            },
                            [_vm._v(_vm._s(list.itemDescription))]
                          ),
                          _vm._v(" "),
                          _c("button", { staticClass: "btn-vote temp3Btn" }, [
                            _vm._v("投票")
                          ])
                        ]
                      )
                    ])
                  })
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.candidateList.length > 0
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showStatus2,
                    expression: "showStatus2"
                  }
                ],
                ref: "temp2",
                staticClass: "template2"
              },
              [
                _c(
                  "ul",
                  { staticClass: "vList" },
                  _vm._l(_vm.candidateList, function(list, index) {
                    return _c("li", { key: index }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showStatus3,
                              expression: "showStatus3"
                            }
                          ],
                          staticClass: "left"
                        },
                        [
                          _c("img", {
                            attrs: { src: list.itemImage, alt: "" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "triangle" }, [
                            _c("p", [_vm._v(_vm._s(list.itemIndex))])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showStatus3,
                              expression: "showStatus3"
                            }
                          ],
                          staticClass: "right"
                        },
                        [
                          _c("div", [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  "padding-top": "12px",
                                  "font-size": "16px",
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                  "white-space": "nowrap",
                                  "margin-bottom": "10px"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.showStatus3,
                                        expression: "!showStatus3"
                                      }
                                    ]
                                  },
                                  [_vm._v(_vm._s(list.itemIndex))]
                                ),
                                _vm._v(_vm._s(list.itemTitle))
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "tip",
                              staticStyle: {
                                "font-size": "14px",
                                "line-height": "23px"
                              }
                            },
                            [_vm._v(_vm._s(list.itemDescription))]
                          ),
                          _vm._v(" "),
                          _c("button", { staticClass: "btn-vote" }, [
                            _vm._v("投票")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.showStatus3,
                              expression: "!showStatus3"
                            }
                          ],
                          staticClass: "right right1"
                        },
                        [
                          _c("div", [
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  padding: "12px 0 0 12px",
                                  "font-size": "16px"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.showStatus3,
                                        expression: "!showStatus3"
                                      }
                                    ]
                                  },
                                  [_vm._v(_vm._s(list.itemIndex))]
                                ),
                                _vm._v(_vm._s(list.itemTitle))
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "tip",
                              staticStyle: {
                                "font-size": "14px",
                                padding: "8px 0 0 12px"
                              }
                            },
                            [_vm._v(_vm._s(list.itemDescription))]
                          ),
                          _vm._v(" "),
                          _c("button", { staticClass: "btn-vote temp3Btn" }, [
                            _vm._v("投票")
                          ])
                        ]
                      )
                    ])
                  })
                )
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }